// src/polaris-components/CustomerPortalButton.tsx
import React from 'react';
import { useCustomerPortal } from '../hooks/useCustomerPortal';

interface CustomerPortalButtonProps {
  className?: string;
  children?: React.ReactNode;
  returnUrl?: string;
}

/**
 * CustomerPortalButton - Opens Stripe Customer Portal for subscription management
 * Allows users to update payment methods, view invoices, and manage their subscription
 */
export const CustomerPortalButton: React.FC<CustomerPortalButtonProps> = ({
  className = '',
  children,
  returnUrl
}) => {
  const { openPortal, isLoading, error } = useCustomerPortal();

  const handleOpenPortal = async () => {
    await openPortal(returnUrl);
  };

  return (
    <>
      <button
        onClick={handleOpenPortal}
        disabled={isLoading}
        className={`portal-btn ${className}`}
        data-testid="customer-portal-btn"
      >
        {isLoading ? (
          <>
            <span className="btn-spinner"></span>
            Loading...
          </>
        ) : (
          children || 'Manage Billing'
        )}
      </button>
      {error && (
        <div className="portal-error" data-testid="portal-error">
          {error}
        </div>
      )}
    </>
  );
};

